import {ReactNode} from "react";
import {css, cx} from "@panda/css";

import {ChevronDownIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {ISortValue} from "../../../types/ISortOption";
import {IPropertySortableField} from "../../interfaces/IPropertySortableField";
import {IPropertySortOption} from "../../interfaces/IPropertySortOption";
import {cellA, cellB, cellC, cellD, cellE} from "./PropertiesTableCell";

/*
    This component is not meant to be used as a standalone business component.
    It should be supplied with a list/rows (in children), so upper level component should be providing that.
    So for example, compose that (properties list/table) with other components related to PropertiesTable,
    like PropertiesTableRow (list/table items)
 */

interface IProps {
    children: ReactNode;
    sort: IPropertySortOption | null;
    toggleSort: (fieldName: IPropertySortableField) => void;
}

interface IColumn {
    fieldName: string;
    text: string;
    additionalCss: string;
}

const columns: IColumn[] = [
    {
        fieldName: "plan",
        text: "Rzut",
        additionalCss: cellA
    },
    {
        fieldName: "rooms",
        text: "Pokoje",
        additionalCss: cellB
    },
    {
        fieldName: "floor",
        text: "Piętro",
        additionalCss: cellC
    },
    {
        fieldName: "area",
        text: "Metraż",
        additionalCss: cellD
    },
    {
        fieldName: "price",
        text: "Cena",
        additionalCss: cellE
    }
];

const sortableFields = ["number", "rooms", "area", "floor", "price"];

export function PropertiesTable(props: IProps) {
    const {children, sort, toggleSort} = props;

    return (
        <div className={tableWrap}>
            <table className={table}>
                <thead>
                    <tr css={tableRowHeader}>
                        {columns.map((column) => {
                            const {fieldName, text, additionalCss} = column;
                            const isSortable = sortableFields.includes(fieldName);

                            const onClick = () => {
                                if (isSortable) {
                                    toggleSort(fieldName as IPropertySortableField);
                                }
                            };

                            return (
                                <Text
                                    as="th"
                                    key={`mpth${fieldName}`}
                                    variant="body_copy_1"
                                    className={cx(headerCell, additionalCss, isSortable && isSortableStyle)}
                                    onClick={onClick}
                                >
                                    <div className={headerCellContent}>
                                        {text}
                                        {isSortable && <SortIcon value={getSortValue(sort, fieldName as IPropertySortableField)} />}
                                    </div>
                                </Text>
                            );
                        })}
                    </tr>
                </thead>

                <tbody>{children}</tbody>
            </table>
        </div>
    );
}

/*
    Sub-components
 */
interface ISortIconProps {
    value: ISortValue | null;
}

function SortIcon(props: ISortIconProps) {
    const {value} = props;

    return (
        <div className={css({opacity: value === null ? "0.5" : "1", transform: value === "asc" ? `rotate(180deg) scale(1.3)` : ""})}>
            <ChevronDownIcon size="1.3" fill="var(--colors-gray-700)" />
        </div>
    );
}

/*
        Utils
 */
function getSortValue(currentSortOption: IPropertySortOption | null, fieldName: IPropertySortableField) {
    if (currentSortOption && currentSortOption.fieldName === fieldName) {
        return currentSortOption.value;
    }

    return null;
}

/*
    Styles
 */
const tableWrap = css({
    overflowX: "hidden",
    mb: 3
});

const table = css({
    width: "100%",
    borderCollapse: "collapse",
    tableLayout: "fixed"
});

const tableRowHeader = css({
    height: "54px"
});

const headerCell = css({
    border: 0,
    fontWeight: "normal",
    verticalAlign: "middle",
    textAlign: "center",
    padding: 0
});

const isSortableStyle = css({
    cursor: "pointer"
});

const headerCellContent = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    columnGap: 0.5,
    minHeight: "54px",

    xs: {
        columnGap: 1
    }
});
import {ReactNode} from "react";
import {css, cx} from "@panda/css";

import {ChevronDownIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {ISortValue} from "../../../types/ISortOption";
import {IPropertySortableField} from "../../interfaces/IPropertySortableField";
import {IPropertySortOption} from "../../interfaces/IPropertySortOption";
import {cellA, cellB, cellC, cellD, cellE} from "./PropertiesTableCell";

/*
    This component is not meant to be used as a standalone business component.
    It should be supplied with a list/rows (in children), so upper level component should be providing that.
    So for example, compose that (properties list/table) with other components related to PropertiesTable,
    like PropertiesTableRow (list/table items)
 */

interface IProps {
    children: ReactNode;
    sort: IPropertySortOption | null;
    toggleSort: (fieldName: IPropertySortableField) => void;
}

interface IColumn {
    fieldName: string;
    text: string;
    additionalCss: string;
}

const columns: IColumn[] = [
    {
        fieldName: "plan",
        text: "Rzut",
        additionalCss: cellA
    },
    {
        fieldName: "rooms",
        text: "Pokoje",
        additionalCss: cellB
    },
    {
        fieldName: "floor",
        text: "Piętro",
        additionalCss: cellC
    },
    {
        fieldName: "area",
        text: "Metraż",
        additionalCss: cellD
    },
    {
        fieldName: "price",
        text: "Cena",
        additionalCss: cellE
    }
];

const sortableFields = ["number", "rooms", "area", "floor", "price"];

export function PropertiesTable(props: IProps) {
    const {children, sort, toggleSort} = props;

    return (
        <div className={tableWrap}>
            <table className={table}>
                <thead>
                    <tr css={tableRowHeader}>
                        {columns.map((column) => {
                            const {fieldName, text, additionalCss} = column;
                            const isSortable = sortableFields.includes(fieldName);

                            const onClick = () => {
                                if (isSortable) {
                                    toggleSort(fieldName as IPropertySortableField);
                                }
                            };

                            return (
                                <Text
                                    as="th"
                                    key={`mpth${fieldName}`}
                                    variant="body_copy_1"
                                    className={cx(headerCell, additionalCss, isSortable && isSortableStyle)}
                                    onClick={onClick}
                                >
                                    <div className={headerCellContent}>
                                        {text}
                                        {isSortable && <SortIcon value={getSortValue(sort, fieldName as IPropertySortableField)} />}
                                    </div>
                                </Text>
                            );
                        })}
                    </tr>
                </thead>

                <tbody>{children}</tbody>
            </table>
        </div>
    );
}

/*
    Sub-components
 */
interface ISortIconProps {
    value: ISortValue | null;
}

function SortIcon(props: ISortIconProps) {
    const {value} = props;

    return (
        <div className={css({opacity: value === null ? "0.5" : "1", transform: value === "asc" ? `rotate(180deg) scale(1.3)` : ""})}>
            <ChevronDownIcon size="1.3" fill="var(--colors-gray-700)" />
        </div>
    );
}

/*
        Utils
 */
function getSortValue(currentSortOption: IPropertySortOption | null, fieldName: IPropertySortableField) {
    if (currentSortOption && currentSortOption.fieldName === fieldName) {
        return currentSortOption.value;
    }

    return null;
}

/*
    Styles
 */
const tableWrap = css({
    overflowX: "hidden",
    mb: 3
});

const table = css({
    width: "100%",
    borderCollapse: "collapse",
    tableLayout: "fixed"
});

const tableRowHeader = css({
    height: "54px"
});

const headerCell = css({
    border: 0,
    fontWeight: "normal",
    verticalAlign: "middle",
    textAlign: "center",
    padding: 0
});

const isSortableStyle = css({
    cursor: "pointer"
});

const headerCellContent = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    columnGap: 0.5,
    minHeight: "54px",

    xs: {
        columnGap: 1
    }
});
